export default __webpack_public_path__ + "media/83dbdc5ada846c621a4723c52f1674ac.png";